import React from "react";
import Image from "components/Elements/Image/Image.tsx";
import { LinkToNewTab } from "../../Elements/Link/Link.js";

export const MoreSolutionsSection = () => {
  return (
    <div className="footer-more-jumbo-solutions">
      <LinkToNewTab page="jumbo-forms">
        <Image
          name="jf_new_small"
          ext="png"
          title="JUMBOforms"
          alt="JUMBOforms"
        />
      </LinkToNewTab>
      <LinkToNewTab page="https://media.jumbomail.me" fullUrl>
        <Image
          name="logo-media-text"
          ext="png"
          title="JUMBOmedia"
          alt="JUMBOmedia"
        />
      </LinkToNewTab>
    </div>
  );
};
